/**
 * 统计卡片组件
 *
 * 用于仪表盘数据展示。
 */

import { Box, Typography, Card, CardContent } from '@mui/material'
import type { ReactNode } from 'react'

interface StatCardProps {
  /** 卡片标题 */
  title: string
  /** 数值 */
  value: string | number
  /** 图标 */
  icon: ReactNode
  /** 主题色 */
  color: string
  /** 副标题/描述 */
  subtitle?: string
}

export function StatCard({ title, value, icon, color, subtitle }: StatCardProps) {
  return (
    <Card sx={{ borderRadius: '12px', height: '100%' }}>
      <CardContent sx={{ p: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#999', fontSize: '13px', mb: 0.5 }}>
              {title}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#333', lineHeight: 1.2 }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="caption" sx={{ color: '#bbb', mt: 0.5, display: 'block' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '12px',
              backgroundColor: `${color}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: color,
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default StatCard
